import {
  SCENE_PLUS_DEEP_LINK,
  IOS_STORE_URL,
  ANDROID_STORE_URL,
  OS_IOS,
  OS_ANDROID,
  OS_UNKNOWN,
} from './constants';

/**
 * Extracts the Scene+ (Okta) callback parameters from a query string.
 *
 * @param {string} search location.search value (e.g. '?code=abc&state=xyz').
 * @returns {{code: ?string, state: ?string, error: ?string, errorDescription: ?string}}
 */
export function parseCallbackParams(search) {
  const params = new URLSearchParams(search);

  return {
    code: params.get('code'),
    state: params.get('state'),
    error: params.get('error'),
    errorDescription: params.get('error_description'),
  };
}

/**
 * Builds the legacy custom-scheme deep link that hands the Okta response to the
 * Shell App. Only the parameters present in the callback are forwarded.
 *
 * @param {{code: ?string, state: ?string, error: ?string, errorDescription: ?string}} callbackParams
 * @returns {string} Deep link URL.
 */
export function buildScenePlusDeepLink({
  code,
  state,
  error,
  errorDescription,
} = {}) {
  const params = new URLSearchParams();

  if (code) {
    params.set('code', code);
  }
  if (state) {
    params.set('state', state);
  }
  if (error) {
    params.set('error', error);
  }
  if (errorDescription) {
    params.set('error_description', errorDescription);
  }

  const query = params.toString();
  return query ? `${SCENE_PLUS_DEEP_LINK}?${query}` : SCENE_PLUS_DEEP_LINK;
}

/**
 * Detects the mobile operating system from the browser User-Agent.
 *
 * @param {string} userAgent navigator.userAgent value.
 * @returns {'ios'|'android'|'unknown'}
 */
export function detectMobileOS(userAgent = '') {
  if (/iP(hone|od|ad)/.test(userAgent)) {
    return OS_IOS;
  }

  if (/android/i.test(userAgent)) {
    return OS_ANDROID;
  }

  return OS_UNKNOWN;
}

/**
 * Returns the app-store URL for the given OS, or null when it cannot be
 * determined.
 *
 * @param {'ios'|'android'|'unknown'} os
 * @returns {?string}
 */
export function getStoreUrl(os) {
  if (os === OS_IOS) {
    return IOS_STORE_URL;
  }
  if (os === OS_ANDROID) {
    return ANDROID_STORE_URL;
  }
  return null;
}
